export default "__VITE_ASSET__TYRpI$No__"